import { Component } from "react";

import {
    ArrayUtil,
    EnvironmentUtil,
    ObjectUtil,
    UuidUtil
} from "@repo/libs/utils";

export default class ComponentBase extends Component {
    
    _uuid = "";
    _actionList = [];

    _isDestroy = false;

    _DEFAULT_PAGING = 1;
    _DEFAULT_PAGING_RECORD = 30;

    /**
     * constructor
     *
     * @param {*} props
     */
    constructor(props) {
        super(props);

        this._uuid = UuidUtil.generate();
    }

    static getDerivedStateFromError(error) {
        if (EnvironmentUtil.isLocalHost()) {
            throw "Error";
        }

        return { __page_error__: true };
    }

    /**
     * componentDidCatch
     *
     * @param {*} error
     * @param {*} errorInfo
     */
    componentDidCatch(error, errorInfo) {
        this._callFunction("_onErrorPage", [error, errorInfo]);
    }

    /**
     * componentDidMount
     */
    componentDidMount() {
        this._callFunction("_onInit");
        this._callFunction("_onReady");
    }

    /**
     * componentWillUnmount
     */
    componentWillUnmount() {
        this._isDestroy = true;

        this._callFunction("_onDestroy");
    }

    /**
     * componentDidUpdate
     */
    componentDidUpdate() {
        if (this._isDestroy) {
            return;
        }

        this._callFunction("_onChange", arguments);
    }

    /**
     * componentWillReceiveProps
     *
     * @param {*} nextProps
     */
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this._isDestroy) {
            return;
        }

        this._callFunction("_onChangeProps", arguments);

        if (ObjectUtil.hasProperty(nextProps, "rNextFunctionAction")) {
            this._processReduxFunction(nextProps);
        }
    }

    /**
     *  processs props value from redux
     *
     * @param {*} nextProps
     */
    _processReduxFunction(nextProps) {
        if (nextProps?.rNextFunctionAction || []) {
            let tArray = (nextProps?.rNextFunctionAction || []).filter(item => {
                return item.compId === this.uuid();
            });

            ArrayUtil.forEach(tArray, item => {
                if (ArrayUtil.contain(this._actionList, item.actionId)) {
                    return;
                }

                this._actionList.push(item.actionId);

                if (this._actionList.length > 20) {
                    this._actionList = ArrayUtil.removeItem(
                        this._actionList,
                        0
                    );
                }

                this._callFunction(item.nextFunctionNameTo, [
                    item.nextFunctionArgs
                ]);
            });
        }
    }

    /**
     *  call child class function
     *
     * @param {*} funcName
     * @param {*} args
     */
    _callFunction(funcName, args) {
        if (this[funcName] instanceof Function) {
            if (args) {
                this[funcName].apply(this, args);
            } else {
                this[funcName].apply(this);
            }
        }
    }

    /**
     * get uuid
     */
    uuid() {
        return this._uuid;
    }

    /**
     * get class name
     */
    className() {
        return this.constructor.name;
    }

    /**
     * get comp id
     */
    compId() {
        return this._uuid;
    }

    /**
     * regenerate comp id
     */
    regenerateCompId() {
        this._uuid = UuidUtil.generate();
    }

    /**
     * trigger event scroll top
     */
    triggerEventScrollTop() {
        /*
         * scroll to top
         */
        setTimeout(() => {
            window.dispatchEvent(new CustomEvent("viewContainerScrollTop"));
        }, 400);
    }

    /**
     * delay function
     *
     * @param {*} func
     * @param {*} delay
     */
    delayFunction(func, delay = 80) {
        setTimeout(() => {
            func();
        }, delay);
    }
}
